import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core'
import { centsToCurrencyString } from 'src/logic/pricing'
import { errorToast } from 'src/toaster'

type Method = 'credit' | 'charge';

@Component({
  selector: 'activate-request-modal',
  template: `
    <modal (outsideClick)="close()" [width]="500">
      <div>
        <i class="far fa-question-circle fa-4x text-dark-blue"></i>
      </div>
      <h4 class="small-top-buffer">Activate your request?</h4>
      <p>
        You <strong>can't edit your request</strong> once you've activated it. Our team
        will get to work on your request right away.
      </p>
      <p>
        <small><em>Don't worry, you'll be able to request edits to your video.</em></small>
      </p>

      <div class="form-check">
        <input class="form-check-input" type="radio" [checked]="method === 'credit'" (click)="setMethod('credit')" [disabled]="availableCredits < 1">
        <label class="form-check-label" (click)="setMethod('credit')">
          Activate with 1 credit
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" [checked]="method === 'charge'" (click)="setMethod('charge')">
        <label class="form-check-label" (click)="setMethod('charge')">
          Activate a la carte for {{priceString}}
        </label>
      </div>

      <button class="btn btn-secondary btn-block mt-4" (click)="activate()" [disabled]="activating">
        Activate my request
      </button>
      <button class="btn btn-outline-secondary btn-block" (click)="close()">Cancel</button>
    </modal>
  `
})
export class ActivateRequestModal implements OnInit {
  @Input() price: number;
  @Input() availableCredits: number;
  @Output() onClose = new EventEmitter();
  @Output() onActivate = new EventEmitter<Method>();
  method: Method = 'credit'
  activating: boolean = false

  ngOnInit(): void {
    this.method = this.availableCredits > 0 ? 'credit' : null // make them select charge
  }

  activate(): void {
    if (this.method) {
      this.activating = true
      this.onActivate.emit(this.method)
    } else {
      errorToast("Please select whether to activate this request using a credit or by charging your card")
    }
  }

  close(): void {
    this.onClose.emit()
  }

  setMethod(m: Method): void {
    if (this.availableCredits < 1) {
      this.method = 'charge'
    } else {
      this.method = m
    }
  }

  get priceString(): string {
    return centsToCurrencyString(this.price)
  }

}
